import { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "danger";
type ButtonSize = "default" | "small" | "full";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  danger: "btn-danger",
};

const SIZE_CLASS: Record<ButtonSize, string> = {
  default: "",
  small: "btn-small",
  full: "btn-full",
};

/**
 * Shared button component that maps variant + size to the existing CSS classes.
 * Use this for new call-sites rather than raw className strings.
 */
export function Button({ variant = "primary", size = "default", className, children, ...rest }: ButtonProps) {
  const variantCls = VARIANT_CLASS[variant];
  const sizeCls = SIZE_CLASS[size];
  const combined = [variantCls, sizeCls, className].filter(Boolean).join(" ");
  return (
    <button type="button" className={combined} {...rest}>
      {children}
    </button>
  );
}
